import React, {ReactElement} from 'react';

import URLS, {getResourcesURL} from '../../../urls';
import SubNav from './SubNav';

type Props = {
  active: 'resources' | 'calculators';
};

const entries = [
  {id: 'resources', url: getResourcesURL(), text: 'Resources'},
  {id: 'calculators', url: URLS.calculators.index, text: 'Calculators'},
];

const AboutNavigation = ({active}: Props): ReactElement => {
  return <SubNav entries={entries} active={active} />;
};

export default AboutNavigation;
